import React, { useEffect, useState } from "react";
import "../../Styles/overview2.css";
import { Select } from "antd";
import OverviewLeft from "../../Components/overview2/OverviewLeft";
import OverviewMap from "../../Components/overview2/OverviewMap";
import OverviewRight from "../../Components/overview2/OverviewRight";
import useAxiosInstance from "../../lib/useAxiosInstance";
import { useQuery } from "react-query";
import useConstituencyData from "../../Components/cdm/hooks/useConstituencyData";
import { useTranslation } from "react-i18next";

const Overview2 = () => {
    const { t } = useTranslation();
  const axiosInstance = useAxiosInstance();
  const user = JSON.parse(localStorage.getItem("user"));
  const { constituencyData } = useConstituencyData(1);
  const constituencyId = constituencyData?._id;

  const [year, setYear] = useState();
  // 🔹 Fetch summary
  const fetchConstituencySummaryById = async (id, year) => {
    return axiosInstance.get(`api/constituency/getConstituencySummaryById/${id}?year=${year}`);
  };

  const summaryQuery = useQuery(
    ["summary-data", constituencyId, year],
    () => constituencyId && year ? fetchConstituencySummaryById(constituencyId, year) : Promise.resolve(null),
    { refetchOnWindowFocus: false, retry: 1 }
  );

  const summaryData = summaryQuery?.data?.data?.data || {};
  const getIsDataAvailable = (summaryData) => {
    const check = (key) => ["YES", "Yes"].includes(summaryData[key]);
    return (
      check("Form 20") &&
      check("Electoral Roll") &&
      check("PS Village Mapping Data") &&
      check("Village Data")
    );
  };

  const isDataAvailable = getIsDataAvailable(summaryData);

  // 🔹 Fetch table if data is available
  const fetchConstituencyTableById = async (id, year) => {
    return axiosInstance.get(`api/constituency/getConstituencyTableById/${id}?years=${year}`);
  };

  const tableQuery = useQuery(
    ["table-data", constituencyId, year],
    () => fetchConstituencyTableById(constituencyId, year),
    { enabled: isDataAvailable && !!year, refetchOnWindowFocus: false, retry: 1 }
  );

  const constituencyTableData = tableQuery?.data?.data?.data;

  // 🔹 Fetch election years
  useEffect(() => {
    if (constituencyId) {
      const fetchYears = async () => {
        try {
          const response = await axiosInstance.get(`api/constituency/getElectionYears/${constituencyId}`);
          setYear(response?.data?.data?.electionYears?.[0]); // pick latest year
        } catch (err) {
          console.error(err);
        }
      };
      fetchYears();
    }
  }, [constituencyId]);

  return (
    <div className="dashboard-container">
      <div className="dashboard-inner">
        <div className="dashboard-bg-animations">
          <div className="bg-gradient-1"></div>
          <div className="bg-gradient-2"></div>
        </div>

        {/* Header */}
        <div className="dashboard-header" data-animate>
          <div className="dashboard-user">
            <div className="overview-username">
              {t("Dashboard.title")}
            </div>
            {/* <div className="overview-username">
              Namaste <span className="username">{user?.prefix} {user?.firstName}</span>
            </div> */}
            <div className="dashboard-welcome">
              {t("Dashboard.subtitle")}
            </div>
          </div>
        </div>

        {/* Main Dashboard Content */}
        <div className="dashboard-grid">
          <OverviewLeft />
          {/* Pass fetched data here */}
          <OverviewMap constituencyTableData={constituencyTableData} isDataAvailable={isDataAvailable} />
          <OverviewRight />
        </div>
      </div>
    </div>
  );
};

export default Overview2;
